import api from '@/libs/axios'
import store from '../index'
import { addOrUpdateInList } from '../../utils/form'
import useAPI from '../../utils/useAPI'

export default {
  getWorkFloUsages ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.workFloUsages.length == 0) {
        api.get('/workFloUsages')
          .then(response => {
            commit('SET_WORKFLOUSAGES', response.data)
            resolve(response)
          })
          .catch(err => {
            console.log('Error', err)
            reject(err)
          })
      } else {
        resolve(true)
      }
    })
  },
  getWorkFloUsage ({ commit, state }, workFloUsageId) {
    store.commit('app/ADD_LOADER')

    return new Promise((resolve, reject) => {
      api.get('/workFloUsages/'+workFloUsageId)
        .then(response => {
          // addOrUpdateInList(response.data, state.workFloUsages, 'workFloUsage',commit)

          store.commit('app/REMOVE_LOADER')
          resolve(response.data)

        })
        .catch(err => {
          console.log('Error', err)
          reject(err)
        })
    })
  },
  getAutocompleteWorkFloUsages ({ commit, state }, payload) {
    const { performApiCall } = useAPI()
    store.commit('app/TOGGLE_LOADING', true)

    return new Promise((resolve, reject) => {
      let url = '/autocomplete/workFloUsages'

      performApiCall(url, payload)
        .then(response => {
          commit('SET_AUTOCOMPLETEWORKFLOUSAGES', response.data.results)
          store.commit('app/TOGGLE_LOADING', false)
          resolve(true)
        })
    })

  },

}